// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"ol_a bhr_a bhr_x","FilterForm__vgroup":"ol_b bhr_sv"};